module.exports = __webpack_public_path__ + "static/media/coffee-cup.344a91f9.svg";